export const checkOffMorning = (timeIn: Date, timeOut: Date) => {
  if (timeIn.getHours() >= 12) {
    return true
  } else if (timeOut.getHours() < 13) {
    return false
  } else {
    //Thời gian làm việc buổi sáng: 12 - timeIn.getHours()
    // Thời gian làm việc buổi chiều: timeOut.getHours() - 13
    return 12 - timeIn.getHours() > timeOut.getHours() - 13
  }
}
